import http from '@/plugins/http'

export default class Departments {
  static all(params) {
    return http.get('departments', {
      params: params,
    })
  }
}
